import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-design-content-chip',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chip.content.design.html',
    styleUrls: ['./chip.content.design.scss'],
    standalone: false
})
export class ChipContentDesign {
  @Input({ required: true }) tooltipLabel!: string;
  @Input() styleClass = 'px-2 py-1 white-space-nowrap overflow-hidden text-overflow-ellipsis';
}
